import { ParsedUrlQuery } from 'querystring';

export function getResultsSort(query: ParsedUrlQuery) {
    const resultsSort = query['results_sort'];

    if (!resultsSort) {
        return '';
    }

    if (Array.isArray(resultsSort)) {
        return resultsSort[0];
    } else {
        return resultsSort;
    }
}
